import { CreatePollRequest, UpdatePollRequest, ViewPollResultsRequest } from './poll.types';

import { API_HOST, HttpPostOptions, HttpPutOptions, getHttpPostOptions, getHttpPutOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/poll`;

export const getCreatePollRequest = (data: CreatePollRequest): [string, HttpPostOptions<CreatePollRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getUpdatePollRequest = (data: UpdatePollRequest): [string, HttpPutOptions<UpdatePollRequest>] => [
  getEndpoint(),
  getHttpPutOptions(data)
];

export const getViewPollResultsRequest = (
  data: ViewPollResultsRequest
): [string, HttpPostOptions<Record<string, never>>] => [
  `${getEndpoint()}/result/${data.programmeExternalReference}/${data.pollExternalReference}`,
  getHttpPostOptions({} as Record<string, never>)
];
